(function () {

  let countdownInterval = null;

  function initSaleCountdown() {

    const section = document.querySelector('.mini-cart-sale-countdown');

    if (!section) return;

    const timer = section.querySelector('[data-countdown-timer]');
    const dateTimeElement = section.querySelector('[data-date-time]');
    const timezoneElement = section.querySelector('[data-timezone]');

    if (!timer || !dateTimeElement || !timezoneElement) {
      return;
    }

    const dateTime = dateTimeElement.textContent.trim();
    const timezoneLabel = timezoneElement.textContent.trim();

    if (!dateTime || !timezoneLabel) {
      return;
    }

    /*
     * Clear previous countdown
     * before creating a new one.
     */
    if (countdownInterval) {
      clearInterval(countdownInterval);
      countdownInterval = null;
    }

    const second = 1000;
    const minute = second * 60;
    const hour = minute * 60;

    const timezoneMap = {
      'Pacific Time (PST/PDT)': 'America/Los_Angeles',
      'Mountain Time (MST/MDT)': 'America/Denver',
      'Central Time (CST/CDT)': 'America/Chicago',
      'Eastern Time (EST/EDT)': 'America/New_York',
      'UTC': 'UTC',
      'Arizona (MST - No DST)': 'America/Phoenix'
    };

    const ianaTimezone =
      timezoneMap[timezoneLabel] || 'UTC';


    function getTimeZoneOffsetMs(timeZone, utcInstant) {

      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        hourCycle: 'h23',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });

      const parts = formatter
        .formatToParts(utcInstant)
        .reduce(function (result, part) {

          if (part.type !== 'literal') {
            result[part.type] = part.value;
          }

          return result;

        }, {});

      const asUTC = Date.UTC(
        Number(parts.year),
        Number(parts.month) - 1,
        Number(parts.day),
        Number(parts.hour),
        Number(parts.minute),
        Number(parts.second)
      );

      return asUTC - utcInstant.getTime();
    }


    function getCountdownDate(dateTimeString, timeZone) {

      const parts = dateTimeString.split('T');

      if (parts.length !== 2) {
        return new Date(NaN);
      }

      const dateValues = parts[0].split('-').map(Number);
      const timeValues = parts[1].split(':').map(Number);

      const year = dateValues[0];
      const month = dateValues[1];
      const dayValue = dateValues[2];

      const hours = timeValues[0];
      const minutes = timeValues[1];
      const seconds = timeValues[2] || 0;

      if (!year || !month || !dayValue) {
        return new Date(NaN);
      }

      const naiveUTC = Date.UTC(
        year,
        month - 1,
        dayValue,
        hours,
        minutes,
        seconds
      );

      const guessDate = new Date(naiveUTC);

      const offsetMs = getTimeZoneOffsetMs(
        timeZone,
        guessDate
      );

      return new Date(naiveUTC - offsetMs);
    }


    const countdownDate = getCountdownDate(
      dateTime,
      ianaTimezone
    );

    if (isNaN(countdownDate.getTime())) {

      console.error(
        'Mini Cart Sale Countdown: Invalid date',
        dateTime
      );

      return;
    }


    const hoursElement =
      timer.querySelector('[data-hours]');

    const minutesElement =
      timer.querySelector('[data-minutes]');

    const secondsElement =
      timer.querySelector('[data-seconds]');

    if (
      !hoursElement ||
      !minutesElement ||
      !secondsElement
    ) {
      return;
    }


    function pad(number) {
      return String(number).padStart(2, '0');
    }


    function updateCountdown() {

      const now = Date.now();

      const distance =
        countdownDate.getTime() - now;


      if (distance <= 0) {

        hoursElement.textContent = '00';
        minutesElement.textContent = '00';
        secondsElement.textContent = '00';

        section.classList.add(
          'sale-countdown--expired'
        );

        clearInterval(countdownInterval);
        countdownInterval = null;

        return;
      }


      const totalHours =
        Math.floor(distance / hour);

      const minutes =
        Math.floor(
          (distance % hour) / minute
        );

      const seconds =
        Math.floor(
          (distance % minute) / second
        );


      hoursElement.textContent =
        pad(totalHours);

      minutesElement.textContent =
        pad(minutes);

      secondsElement.textContent =
        pad(seconds);
    }


    updateCountdown();

    countdownInterval =
      setInterval(updateCountdown, 1000);
  }


  /*
   * Initial load
   */

function delayedSaleCountdown() {
  setTimeout(function () {
    initSaleCountdown();
  }, 2000);
}

document.addEventListener(
  'DOMContentLoaded',
  delayedSaleCountdown
);

document.addEventListener(
  'cart:update',
  delayedSaleCountdown
);

})();